import React, { useEffect } from "react";
import { Container, Content, Heading } from "./ServicePlanManagementPage.styles";
import { ServicePlanCard, Plan, ServiceName } from "uis/ServicePlan";
import UI from "@mile-meeting/mile-ui";
import { getPricePlan, TPricePlan } from "apis/workspace/pricing-plan";
import { getMeetingRoomList } from "apis/meetings/meeting-room";
import { MileMeetingPlan } from "uis/ServicePlan/ServicePlanCard/types";

const ServicePlanManagementPage: React.FC = () => {
  const [meetingPlan, setMeetingPlan] = React.useState<TPricePlan | null>(null);
  const [visitorPlan, setVisitorPlan] = React.useState<TPricePlan | null>(null);
  const [usedMeetingRoomNum, setUsedMeetingRoomNum] = React.useState<number>(0);

  useEffect(() => {
    const fetchPricePlan = async () => {
      const meetingPlan = await getPricePlan("MEETING");
      const visitorPlan = await getPricePlan("VISITORS");
      setMeetingPlan(meetingPlan?.data ?? null);
      setVisitorPlan(visitorPlan?.data ?? null);

      const meetingRoomNum = await getMeetingRoomList(1, [], [], 100, false);
      setUsedMeetingRoomNum(meetingRoomNum.data?.totalSearchNumber ?? 0);
    };
    fetchPricePlan();
  }, []);

  const handlePlanInquiry = () => {
    window.open("https://mile.channel.io/home");
  };

  return (
    <Container>
      <Heading>
        <div className="title">
          <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-neutral)">
            서비스 플랜 관리
          </UI.Typography>
        </div>
        <div className="btn_container">
          <UI.Button
            title="플랜 문의하기"
            prefixIcon={"support"}
            showPrefixIcon
            aria-label="플랜 문의하기 버튼"
            onClick={handlePlanInquiry}
          />
        </div>
      </Heading>
      <Content>
        <ServicePlanCard
          serviceName={ServiceName.MEETING}
          plan={meetingPlan?.plan === MileMeetingPlan.FREE ? Plan.FREE : Plan.BASIC}
          usedTablet={meetingPlan?.plan === MileMeetingPlan.PAID_TABLET}
          planStartedAt={meetingPlan?.planStartedAt}
          planEndedAt={meetingPlan?.planExpiredAt}
          enableMeetingRoom={meetingPlan?.limitMeetingRoomNum}
          usingMeetingRoom={usedMeetingRoomNum}
        />
        <ServicePlanCard
          serviceName={ServiceName.VISITORS}
          plan={visitorPlan ? (visitorPlan?.plan === MileMeetingPlan.FREE ? undefined : Plan.BASIC) : undefined}
          usedTablet={true}
          planStartedAt={visitorPlan?.planStartedAt}
          planEndedAt={visitorPlan?.planExpiredAt}
        />
      </Content>
    </Container>
  );
};

export default ServicePlanManagementPage;
